// Remove trailing slash from the URL
export const removeTrailingSlash = (url: string): string => {
  return url.replace(/\/$/, '');
};

/**
 *
 * @param - An object containing key-value pairs for query parameters.
 * @returns - A string representing the query parameters formatted for a URL.
 */

export const buildQueryParams = (
  params: Record<string, string | string[] | undefined>,
) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val) => {
        if (val !== '') searchParams.append(`${key}[]`, val);
      });
    } else if (value !== undefined && value !== '') {
      searchParams.set(key, value);
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : '';
};
